/**
 * 全国热点
 * 2017-11-19
 * Bai.Zhiming
 */
"use strict";
angular.module("nationalHotSpotsModule", []).
controller("nationalHotSpotsCtrl", ["$scope", "$state", "$q", "$filter", "trsHttpService", function($scope, $state, $q, $filter, trsHttpService) {
    initStatus();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            threeHot: {
                hotqg: "hot",
            }
        };
    }

}]);